import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import SuccessPage from 'components/foundation/SuccessPage/SuccessPage';
import { ReactNode } from 'react';
import { t } from 'utils/localize';
import './OnboardingSuccessPage.scss';

export interface IOnboardingSuccessPageProps {
  memberName: string;
  children: ReactNode;
  className?: ClassName;
}

function OnboardingSuccessPage({ memberName, children, className }: IOnboardingSuccessPageProps) {
  const classes = classNames('onboarding-success-page', className);

  return (
    <div className={classes}>
      <SuccessPage title={t('Setup Complete!')} subtitle={`${t('Welcome')} ${memberName}!`}>
        {children}
      </SuccessPage>
    </div>
  );
}

export default OnboardingSuccessPage;
